import type { JobPipelineStage } from "@talpipe/types"

const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/

/**
 * Exposes a stage's stored hex as `--stage-color` for the `stage-*` classes in
 * assets/css/stage-colors.css. Returns undefined for stages without a valid
 * color so the CSS muted fallback applies.
 */
export function stageColorVars(
  color: string | null | undefined,
): Record<string, string> | undefined {
  if (!color || !HEX_COLOR.test(color)) return undefined
  return { "--stage-color": color }
}

/** Stage id → color, for surfaces that only carry stage ids (e.g. stage history). */
export function stageColorsById(stages: JobPipelineStage[]): Map<string, string | null> {
  return new Map(stages.map((stage) => [stage.id, stage.color]))
}
